<svg
  width="28"
  height="29"
  viewBox="0 0 28 29"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M14 2.833A17.85 17.85 0 0 1 18.667 14.5 17.85 17.85 0 0 1 14 26.167m0-23.334A17.85 17.85 0 0 0 9.333 14.5 17.85 17.85 0 0 0 14 26.167m0-23.334C7.557 2.833 2.333 8.057 2.333 14.5S7.557 26.167 14 26.167m0-23.334c6.443 0 11.667 5.224 11.667 11.667S20.443 26.167 14 26.167M2.917 11h22.166M2.917 18h22.166"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <rect
    x="24.026"
    y="2.793"
    width="3"
    height="31"
    rx="1.5"
    transform="rotate(47.152 24.026 2.793)"
    fill="currentColor"
    stroke="#fff"
  />
</svg>
